/**
 * Copyright (C) IRT GmbH 2020
 */

var QS = require('hbbtv-lib/tools/query_string').get;

var debug = QS("debug");

var AppMan = require('hbbtv-lib/main/appman');

var required_keyset = AppMan.RED | AppMan.NAVIGATION | AppMan.NUMERIC;

var EventEmitter = require('events');

var _KeyEvent = require('../tools/keyevent_constants');

var F = require('../tools/functions');
var createElement = F.createElement;
var createBtn = F.createButton;

var menuInstructionText = "Navigieren Sie mit den Pfeiltasten im Menü und bestätigen Sie Ihre Auswahl mit der OK-Taste.";

var EVENT_TRACK_ACTIVATED = "trackactivated";

var EVENT_CLOSE = "close";

/**
 * @typedef MainPageOptions
 * @param {boolean} enableStatus enables a text block for status messages.
 * @param {string} title short title like Dialog + or Audio Deskription
 * @param {string} usageInstructions default privacy text, that is shown at the top of the page, before any status message and the menu.
 */

/**
 * Creates the main page of the BR 2020 media sync applications for multistream and multidevice audio synchronisation.
 *
 * The status field can be enabled and used to present a short a message to the user. Initially it is "unbekannt", set it via setEnabled.
 *
 * The modules visibility is controlled by the user and can't be set from outside.
 *
 * helpPage and privacyPage are full screen pages that can be opened via a menu on the main page, they need to provide a close event.
 *
 * @param {Element} parent
 * @param {HelpPage} helpPage an instance of HelpPage module
 * @param {PrivacyPage} privacyPage an instance of PrivacyPage Module
 * @param {MainPageOptions} opt
 */
function MainPage(parent, opt, helpPage, privacyPage) {

    var emitter = new EventEmitter();

    var pageElement = createElement(parent, "div", "main-page");

    // header with title and optional on-off button
    var header = createElement(pageElement, "div", "header");
    createElement(header, "div", "title", opt.title);

    var focussed = 0;
    var activeTrack = -1;

    // main area with text blocks and menu
    var mainArea = createElement(pageElement, "div", "main-area");

    var usageInstructionsText = null;
    var usageInstructions = createElement(mainArea, "p", "usage-instructions");
    setUsageInstructions(opt.usageInstructions.noContentAvailable);

    var statusMessage = null;
    if (opt.enableStatus) {
        //statusMessage = mainArea.appendChild(document.createElement("p"));
        statusMessage = createElement(mainArea, "p", "status");
        setStatus("unbekannt");
    }

    if (!opt.disableMenuInstructions)
        createElement(mainArea, "p", "menu-instructions", menuInstructionText);

    var tracksMenu = createElement(mainArea, "div", "menu tracks hidden");
    var trackButtons = [];
    var tracks = [];

    var menu = createElement(mainArea, "div", "menu");
    var helpBtn = createElement(menu, "div", "menu-item", opt.helpButton);
    var privBtn = createElement(menu, "div", "menu-item", opt.privButton);
    var menuButtons = [helpBtn, privBtn];
    var menuButtonsPages = [helpPage, privacyPage];

    var buttons = trackButtons.concat(menuButtons);

    // focus first menu item if there is no on off button
    if (focussed === 0) menuButtons[0].classList.add("selected");

    if (opt.images && opt.images.length > 0) {
        var appstores = createElement(mainArea, "div", "app-store-images");
        for (x in opt.images) {
            var img = opt.images[x];
            var app_img = createElement(appstores, "img");
            app_img.setAttribute("src", img);
        }
    }

    var btnBar = createElement(pageElement, "div", "colour-button-bar");
    createBtn(btnBar, "0", "white", opt.backtostart);
    var redBtn1 = createBtn(btnBar, ".", "red", "Menü ausblenden");

    var btnBar2 = createElement(parent, "div", "colour-button-bar hidden background");
    var redBtn2 = createBtn(btnBar2, ".", "red", "Menü einblenden");

    redBtn2.style.width = (redBtn1.clientWidth * 1) + "px";
    // console.log(redBtn2.style.width, redBtn1.clientWidth, redBtn2.clientWidth)
    show(true);

    /**
     * Move focus/selected indicator up.
     * If first menu item is selected and on-off button available, let it grab focus, if not, do nothing.
     */
    function up() {
        if (focussed > 0) {
            buttons[focussed].classList.remove("selected");
            focussed--;
            buttons[focussed].classList.add("selected");
        }
    }

    /**
     * Move focus/selected indicator down.
     * If last menu item is selected, do nothing.
     * If on-off button is present and active (selected equals -1), then remove focus and select first menu item.
     */
    function down() {
        if (focussed < buttons.length - 1) {
            buttons[focussed].classList.remove("selected");
            focussed++;
            buttons[focussed].classList.add("selected");
        }
    }

    /**
     * The key handler if page is visible.
     *
     * @param {*} evt
     */
    function handleButtonsIfVisible (evt) {
//         console.log(evt.keyCode);
        switch (evt.keyCode) {
            case evt.VK_LEFT: case _KeyEvent.VK_LEFT:
            case evt.VK_RIGHT: case _KeyEvent.VK_RIGHT:
                if (focussed < 0) return;
                break;
            case evt.VK_UP: case _KeyEvent.VK_UP:
                up();
                break;
            case evt.VK_DOWN: case _KeyEvent.VK_DOWN:
                down();
                break;
            case evt.VK_ENTER: case _KeyEvent.VK_ENTER:
                if (!launchSubPage()) return;
                break;
            case evt.VK_RED: case _KeyEvent.VK_RED:
                show(false, true);
                break;
            case evt.VK_0: case _KeyEvent.VK_0:
                // AppMan.createApp(opt.startleiste);
                emitter.emit(EVENT_CLOSE);
                break;
            case evt.VK_BACK: case _KeyEvent.VK_BACK:
                if (debug) {
                    emitter.emit(EVENT_CLOSE, "../msp_static/index.html");
                }
                break;
            default:
//                console.log("default: ", _KeyEvent, evt);
                return;
        }
        evt.preventDefault();
    }

    /**
     * Key Handler if page is made invisible and waiting for red button to be shown again.
     *
     * @param {*} evt
     */
    function handleButtonsIfInvisible (evt) {
        switch (evt.keyCode) {
            case evt.VK_RED: case _KeyEvent.VK_RED:
                show(true, false);
                break;
            default:
                return;
        }
        evt.preventDefault();
    }

    /**
     * Set a status message. Requires enableStatus to be set in opt object.
     */
    function setStatus(status) {
        if (statusMessage) {
            if (typeof status == "string" && status.length > 0) {
                statusMessage.classList.remove('hidden');
                statusMessage.innerHTML = "Status: " + status;
            } else {
                statusMessage.classList.add('hidden');
                statusMessage.innerHTML = "";
            }
        }
    }

    /**
     * Sets the first text paragraph on the page which contains usage instructions, i.e. what the user should do to enable sync.
     *
     * @param {string|Array<string>} text
     */
    function setUsageInstructions(text) {
        if (text !== usageInstructionsText) {
            if (typeof text == "string") {
                usageInstructions.innerHTML = text;
            } else {
                usageInstructions.innerHTML = "";
                for (x in text) {
                    createElement(usageInstructions, "p", null, text[x]);
                }
            }
        }
    }

    /**
     *
     * @param {Track} _track
     */
    function markTrackActive(_track) {
        _markTrackActive(tracks.indexOf(_track));
    }

    /**
     *
     * @param {number} trackId
     */
    function _markTrackActive(trackId) {
        if (activeTrack != trackId) {
            trackButtons[activeTrack].classList.remove('active');
            activeTrack = trackId;

            emitter.emit(EVENT_TRACK_ACTIVATED, tracks[activeTrack]);
            trackButtons[activeTrack].classList.add('active');
        }
    }

    function launchSubPage() {
//        console.log(focussed, trackButtons.length);
        if (focussed >= trackButtons.length) {
            var p = menuButtonsPages[focussed - trackButtons.length];

            if (p) {
                p.show(true);
                show(false, false);
                p.once("close", function () {
                    show(true, false);
                });
            }
            return true;
        } else if (trackButtons.length > 0) {
            // reset active flag
            // fire event
            _markTrackActive(focussed);
            return true;
        }
        return false;
    }

    var redbutton_timeout = null;

    /**
     * Shows and hides this main page based on parameter 'visible',
     * If backwithred is set, shows a red button for a couple of seconds and
     * waits for the red button to be pressed.
     *
     * Updates the HbbTV Keyset as required.
     *
     * @param {boolean} visible
     * @param {boolean} backWithRed
     */
    function show (visible, backWithRed) {
        if (visible) {
            document.addEventListener("keydown", handleButtonsIfVisible, false);
            pageElement.classList.remove("hidden");
            AppMan.addKey(required_keyset);
        }
        else {
            document.removeEventListener("keydown", handleButtonsIfVisible, false);
            pageElement.classList.add("hidden");
        }
        if (backWithRed) {
            document.addEventListener("keydown", handleButtonsIfInvisible, false);
            btnBar2.classList.remove("hidden");
            redbutton_timeout = setTimeout(function() {
                btnBar2.classList.add("hidden");
                redbutton_timeout = null;
            }, 10000);
            AppMan.remKey(required_keyset);
            AppMan.addKey(AppMan.RED);
        } else {
            document.removeEventListener("keydown", handleButtonsIfInvisible, false);
            btnBar2.classList.add("hidden");
            if (redbutton_timeout) {
                clearTimeout(redbutton_timeout);
                redbutton_timeout = null;
            }
        }
    }

    /**
     * @typedef Track
     * @property {string} title   the text label for the track menu entry
     * @property {string} id the id that will be emitted with the trackselected event.
     */

    /**
     * @param {Array<Track>} _tracks
     */
    function setTracks (_tracks) {
        tracksMenu.innerHTML = "";
        tracksMenu.classList.remove("hidden");

        var oldLength = trackButtons.length;
        trackButtons = [];
        tracks = _tracks;

        var dpCount = 0;

        for (x in _tracks) {
            var title = _tracks[x].title;
            switch (_tracks[x].serviceType) {
            case "DIALOGPLUS":
                title = "Dialog+ " + (++dpCount) + ": " + title;
                break;
            }
            var t = createElement(tracksMenu, "div", "menu-item", title);
            trackButtons.push(t);
            createElement(t, "span", "speaker");
            if (_tracks[x].active) {
                t.classList.add("active");
                activeTrack = x;
            }
        }
        buttons = trackButtons.concat(menuButtons);

        if (focussed >= oldLength) {
            focussed = focussed + trackButtons.length - oldLength;
        } else {
            focussed = 0;
            buttons[0].classList.add("selected");
        }
    }

    return {
        EVENT_CLOSE : EVENT_CLOSE,
        EVENT_TRACK_ACTIVATED : EVENT_TRACK_ACTIVATED,
        on : emitter.on.bind(emitter),
        off : emitter.removeListener.bind(emitter),
        allOff : emitter.removeAllListeners(emitter),
        once : emitter.once.bind(emitter),
        setTracks : setTracks,
        markTrackActive : markTrackActive,
        setUsageInstructions : setUsageInstructions,
        setStatus : setStatus,
        show : show
    };
}

module.exports = MainPage;
